<div class="relative w-3/4 h-3/4 flex flex-row justify-center items-center gap-16">
  <div class="relative w-2/5">
    <img
      class="w-full h-full flex justify-center items-center object-contain"
      [src]="logoUrl"
      alt=""
    />
  </div>
  <div class="relative w-3/5">
    @if (iframeUrl) {
      <iframe
        class="w-full h-full aspect-video"
        [src]="iframeUrl"
        allow="fullscreen"
        allowfullscreen
      ></iframe>
    }
  </div>
</div>
